import type { IconConfig } from './types'

export const CANONICAL_SIZE = 86
export const PREVIEW_SIZE = 280
export const EXPORT_SIZES = [86, 108, 128, 172] as const

export const SHAPE_HALF = 42.7
export const SAFE_ZONE_INSET = 8.5
export const SNAP_STEP = 4

export const DEFAULT_EMOJI_SIZE = 40

export const GRID_OVERLAY_COLOR = 'rgba(255,255,255,0.18)'
export const SAFE_ZONE_OVERLAY_COLOR = 'rgba(255,255,255,0.6)'

export const DEFAULT_CONFIG: IconConfig = {
  corners: {
    tl: true,
    tr: true,
    bl: true,
    br: true,
  },
  background: {
    type: 'linear',
    color: '#2d4263',
    gradientStart: '#3fc1c9',
    gradientEnd: '#364f6b',
    angle: 135,
  },
  innerFrame: {
    enabled: false,
    inset: SAFE_ZONE_INSET,
    background: {
      type: 'solid',
      color: '#ffffff',
      gradientStart: '#ffffff',
      gradientEnd: '#cccccc',
      angle: 135,
    },
  },
  contents: [],
  appName: 'harbour-myapp',
  useTwemoji: false,
}
